import { z } from 'zod'

export const CONTACT_SOURCES = [
  'header',
  'hero',
  'pricing_essentials',
  'pricing_everything',
  'pricing_custom',
  'final_cta',
  'question',
  'summer_offer',
] as const

export type ContactSource = (typeof CONTACT_SOURCES)[number]

export const contactLeadSchema = z
  .object({
    source: z.enum(CONTACT_SOURCES),
    gym_name: z
      .string()
      .max(200)
      .transform((v) => v.trim())
      .optional(),
    contact_name: z
      .string()
      .max(200)
      .transform((v) => v.trim())
      .optional(),
    email: z
      .string()
      .email('Invalid email address')
      .max(200)
      .transform((v) => v.toLowerCase()),
    message: z
      .string()
      .max(2000)
      .transform((v) => v.trim())
      .optional(),
    turnstile_token: z.string().min(1, 'Missing captcha token'),
  })
  // "question" is a lightweight form (email + message only) — every other topic
  // requires gym name and contact name, and doesn't require a message.
  .refine((data) => data.source === 'question' || !!data.gym_name, {
    message: 'Gym name is required',
    path: ['gym_name'],
  })
  .refine((data) => data.source === 'question' || !!data.contact_name, {
    message: 'Your name is required',
    path: ['contact_name'],
  })
  .refine((data) => data.source !== 'question' || !!data.message, {
    message: 'Message is required',
    path: ['message'],
  })

export type ContactLeadInput = z.infer<typeof contactLeadSchema>
